import React from 'react';

const MoveItemsButton = ({ moveItems }) => {
    const handleMouseDown = (event) => {
        // Trigger on left click
        if (event.button === 0) {
            moveItems(event);
        }
    };

    return (
        <span className="btn-tertiary dropdown-link no-select ml1 mr1" onMouseDown={handleMouseDown}>Move</span>
    );
};

export default MoveItemsButton;
